const ROUTES_CONFIG = {
	ADMIN_URL: import.meta.env.VITE_ADMIN_URL || 'http://localhost:5001',
	CLIENT_URL: import.meta.env.VITE_CLIENT_URL || 'http://localhost:5002',
} as const;

export const APP_ROUTES = {
	ADMIN: {
		BASE: ROUTES_CONFIG.ADMIN_URL,
		LOGIN: `${ROUTES_CONFIG.ADMIN_URL}/login`,
		HOME: `${ROUTES_CONFIG.ADMIN_URL}`,
		DASHBOARD: `${ROUTES_CONFIG.ADMIN_URL}/dashboard`,
		REGISTER: `${ROUTES_CONFIG.ADMIN_URL}/register`,
	},
	CLIENT: {
		BASE: ROUTES_CONFIG.CLIENT_URL,
		LOGIN: `${ROUTES_CONFIG.CLIENT_URL}/login`,
		HOME: `${ROUTES_CONFIG.CLIENT_URL}`,
		DASHBOARD: `${ROUTES_CONFIG.CLIENT_URL}/dashboard`,
		REGISTER: `${ROUTES_CONFIG.CLIENT_URL}/register`,
	},
} as const;

type AppKey = keyof typeof APP_ROUTES;
type RouteKey = keyof (typeof APP_ROUTES)['ADMIN'];

export const getRedirectUrl = (
	app: 'admin' | 'client',
	route: 'login' | 'home' | 'dashboard' | 'register'
): string => {
	const appKey = app.toUpperCase() as AppKey;
	const routeKey = route.toUpperCase() as RouteKey;

	const selectedApp = APP_ROUTES[appKey] as Record<string, string>;
	return selectedApp[routeKey] || selectedApp['BASE'];
};
